// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bb2f6fe","453":"f091ad37","563":"d14a0d3b","867":"006b1702","977":"9e24e86b"}[chunkId] + ".chunk.js";
};